import ReactIcon from '@ant-design/icons-react';
export function setTwoToneColor(primaryColor) {
  return ReactIcon.setTwoToneColors({
    primaryColor: primaryColor
  });
}
export function getTwoToneColor() {
  var colors = ReactIcon.getTwoToneColors();
  return colors.primaryColor;
}
//# sourceMappingURL=twoTonePrimaryColor.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/icon/twoTonePrimaryColor.js
// module id = 785
// module chunks = 0